import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import Footer1  from '../Components/Footer1';
import Footer2  from '../Components/Footer2';
import Footer3  from '../Components/Footer3';
class Footer extends React.Component {
    render() {
         return <div>
            <Footer3/>
<footer class="footer-section section bg-gray">

   {/*  <!--Footer Top start--> */}
    <Footer1 />
   {/*  <!--Footer Top end-->

    <!--Footer bottom start--> */}
   <Footer2/>
{/*     <!--Footer bottom end--> */}

</footer>
</div>
    }
}
export default Footer;